import React from 'react'
import styled from '@emotion/styled'
import { colors, radius, spacing } from '@mobi/component-library/Foundations'

const enum LocalConstants {
  ShareBetCardContainerClass = 'bet-selection-display__card',
  SharedBetWinResultClass = 'bet-selection-display__win-result',
  SharedBetNoPayoutResultClass = 'bet-selection-display__no-payout-result',
}

const Container: React.FC<{
  children: React.ReactNode
  displayStatus: 'win' | 'loss' | null
  styleOverride?: React.CSSProperties
}> = ({ displayStatus, styleOverride, children }) => {
  return (
    <WrapperStyled
      style={styleOverride}
      className={
        displayStatus === 'win'
          ? LocalConstants.SharedBetWinResultClass
          : displayStatus === 'loss'
            ? LocalConstants.SharedBetNoPayoutResultClass
            : ''
      }
    >
      {children}
    </WrapperStyled>
  )
}

const Inner: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className={LocalConstants.ShareBetCardContainerClass}>{children}</div>
)

export const BetSelectionContainer = {
  Container,
  Inner,
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
  padding: spacing.sm,
  borderRadius: radius.lgx1,
  backgroundImage: `repeating-linear-gradient(26deg, ${colors.neutral[300]}, ${colors.neutral[300]} 14px, transparent 14px, transparent 28px, ${colors.neutral[300]} 28px), repeating-linear-gradient(116deg, ${colors.neutral[300]}, ${colors.neutral[300]} 14px, transparent 14px, transparent 28px, ${colors.neutral[300]} 28px), repeating-linear-gradient(206deg, ${colors.neutral[300]}, ${colors.neutral[300]} 14px, transparent 14px, transparent 28px, ${colors.neutral[300]} 28px), repeating-linear-gradient(296deg, ${colors.neutral[300]}, ${colors.neutral[300]} 14px, transparent 14px, transparent 28px, ${colors.neutral[300]} 28px)`,
  backgroundSize: '1px 100%, 100% 1px, 1px 100% , 100% 1px',
  backgroundPosition: '0 0, 0 0, 100% 0, 0 100%',
  backgroundRepeat: 'no-repeat',

  [`&.${LocalConstants.SharedBetWinResultClass}`]: {
    filter: `drop-shadow(0 0 ${spacing.smx2} ${colors.celery[300]})`,
    border: `0.3rem solid ${colors.celery[500]}`,
    background: colors.white,
  },

  [`&.${LocalConstants.SharedBetNoPayoutResultClass}`]: {
    background: 'none',
    border: `0.3rem solid ${colors.neutral[300]}`,
  },

  [`.${LocalConstants.ShareBetCardContainerClass}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.smx1,
  },
})
